"use client";
import { Briefcase, Award, Users } from "lucide-react";
import Image from 'next/image';
import { Card, CardContent } from "../ui/card";

export function CareersMarketing() {
  return (
    <>
      <div className="bg-green-600 text-white py-6">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center">
            <h1 className="text-4xl lg:text-5xl font-bold mb-4">Unisciti al Nostro Team</h1>
            <p className="text-xl opacity-90 max-w-3xl mx-auto">
              Cerchi una carriera stimolante nel settore dei servizi ambientali? Offriamo opportunità di crescita in un&apos;azienda leader del settore.
            </p>
          </div>
        </div>
      </div>

      <section className="py-16">
        <div className="max-w-[1320px] mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
            <div>
              <h2 className="text-3xl lg:text-4xl text-gray-900 mb-8">Perché Lavorare con Noi?</h2>
              <div className="space-y-8">
                <div className="flex items-start">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                    <Briefcase className="w-8 h-8 text-green-600" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-semibold text-gray-900 mb-3">Formazione Continua</h3>
                    <p className="text-lg text-gray-600 leading-relaxed">Aggiornamento costante su tecniche innovative, normative del settore e utilizzo di nuove tecnologie. Investiamo nella crescita dei nostri tecnici con corsi specializzati e certificazioni professionali.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                    <Award className="w-8 h-8 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-semibold text-gray-900 mb-3">Crescita Professionale</h3>
                    <p className="text-lg text-gray-600 leading-relaxed">Opportunità concrete di avanzamento di carriera in un settore in continua espansione. Promuoviamo i nostri talenti dall&apos;interno e offriamo percorsi di crescita personalizzati per ogni profilo.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                    <Users className="w-8 h-8 text-purple-600" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-semibold text-gray-900 mb-3">Team Affiatato</h3>
                    <p className="text-lg text-gray-600 leading-relaxed">Ambiente di lavoro stimolante con un team giovane e dinamico. Collaborazione e supporto reciproco sono i nostri punti di forza, insieme a un clima aziendale positivo e inclusivo.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="relative w-full h-80 lg:h-96 rounded-2xl overflow-hidden shadow-2xl">
                <Image 
                  src="/images/optimized/foto-4.webp"
                  alt="Team al lavoro"
                  fill
                  priority={false}
                  placeholder="empty"
                  sizes="(max-width: 1024px) 100vw, 50vw"
                  className="object-cover"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="relative w-full h-32 rounded-xl overflow-hidden shadow-lg">
                  <Image
                    src="/foto 11.jpeg"
                    alt="Formazione tecnica"
                    fill
                    placeholder="empty"
                    sizes="(max-width: 768px) 50vw, 25vw"
                    className="object-cover"
                  />
                </div>
                <div className="relative w-full h-32 rounded-xl overflow-hidden shadow-lg">
                  <Image
                    src="/foto 10.jpeg"
                    alt="Ambiente moderno"
                    fill
                    placeholder="empty"
                    sizes="(max-width: 768px) 50vw, 25vw"
                    className="object-cover"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mb-16">
            <h2 className="text-3xl lg:text-4xl text-gray-900 text-center mb-12">Cosa Offriamo ai Nostri Collaboratori</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {benefits.map(b => (
                <Card key={b.title} className="text-center p-6 border-0 shadow-lg hover:shadow-xl transition-shadow">
                  <CardContent className="p-0">
                    <div className={`w-16 h-16 ${b.bg} rounded-full flex items-center justify-center mx-auto mb-4`}><span className="text-2xl">{b.emoji}</span></div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{b.title}</h3>
                    <p className="text-gray-600">{b.desc}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

const benefits = [
  { title: 'Stipendio Competitivo', desc: 'Retribuzione allineata al mercato con bonus performance', emoji: '💰', bg: 'bg-green-100' },
  { title: 'Auto Aziendale', desc: 'Veicolo attrezzato per spostamenti e interventi', emoji: '🚗', bg: 'bg-blue-100' },
  { title: 'Formazione Pagata', desc: 'Corsi di aggiornamento e certificazioni professionali', emoji: '📚', bg: 'bg-purple-100' },
  { title: 'Flessibilità', desc: 'Orari di lavoro flessibili e work-life balance', emoji: '⏰', bg: 'bg-yellow-100' },
];
